import React from "react";

export const Run = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24.64 22.73"
        xmlSpace="preserve"
        width="1em" height="1em" fill="currentColor"
    >
        <path
            d="m6.35 5.92.06-.28c.23-.8 1.06-1.15 1.82-.73.61.33 1.22.69 1.82 1.03 2.42 1.38 4.85 2.76 7.27 4.14.16.09.32.2.46.33.51.5.51 1.21.01 1.71-.13.13-.27.23-.43.33-3.01 1.84-6.01 3.69-9.02 5.52-.2.12-.43.18-.65.27h-.34c-.02-.01-.03-.02-.05-.02-.47-.1-.75-.4-.89-.85-.03-.1-.04-.19-.07-.29.01-3.72.01-7.44.01-11.16zm1.41 10.89.23-.13c1.01-.62 2.01-1.23 3.02-1.85 1.84-1.12 3.67-2.25 5.51-3.37.09-.05.17-.12.28-.2-3.03-1.72-6.02-3.43-9.04-5.15v10.7z"
        />
    </svg>
)